import PhishingPage from 'components/standard/mudmanage/Phishingpage'

function Phishingpage() {
  return <PhishingPage />
}

export default Phishingpage;
